module.exports = __webpack_public_path__ + "static/media/rocket.b28d5e4d.svg";